import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './WorkflowTask.scss'
import HrbTranslate from '../../language/HrbTranslate';
import HelpLink from '../common/HelpLink';

const WorkflowTaskDescriptionWithHelp = (props) => {
    return (
        <Fragment>
            <div className='column is-1' />
            <div className='column is-8'>
                {props.descriptions && props.descriptions.map((d,n) => (
                    <Fragment key={`wtdesc_${n}`}>
                        {n !== 0 &&
                            <br />
                        }                            
                        <p className={classnames({
                            'p2': !props.classNames,
                            [(props.classNames || '')]: props.classNames
                        })} >
                            <HrbTranslate text={d} params={props.params && props.params[n] ? props.params[n] : {}} />
                        </p>
                    </Fragment>
                ))}
            </div>
            <div className='column is-2'>
                {props.helpKey &&
                    <HelpLink helpKey={props.helpKey} />
                }
            </div>
            <div className='column is-1' />
        </Fragment>
    );
}

WorkflowTaskDescriptionWithHelp.propTypes = {
    descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    params: PropTypes.arrayOf(PropTypes.string),
    classNames: PropTypes.string,
    helpKey: PropTypes.string
}

export default WorkflowTaskDescriptionWithHelp